<template>
	<section id="contacts">
		<div class="container">
		<h3>Contact Me</h3>
		<form id="my-form" 
				action="https://formspree.io/f/xlezpkdg" 
				method="POST">
			<div class="row uniform">
				<div class="6u 12u(xsmall)"><input type="text" name="name" id="name" placeholder="Name" required/></div>
				<div class="6u 12u(xsmall)"><input type="email" name="email" id="email" placeholder="Email" required/></div>
			</div>
			<div class="row uniform">
				<div class="12u"><input type="text" name="subject" id="subject" placeholder="Subject" required/></div>
			</div>
			<div class="row uniform">
				<div class="12u"><textarea name="message" id="message" placeholder="Message" rows="6" required></textarea></div>
			</div>
			<!-- <div class="alert">The brrown dirty fox jusmped over the dog!</div> -->
			<div class="row uniform">
				<div class="12u">
					<ul class="actions">
						<div class="g-recaptcha" 
							data-sitekey="6Lf4LjUcAAAAAAhdUbZhuZ-D5UJLRL4X4cjcFys1"></div> <!-- replace with your recaptcha SITE key not secret key -->
					</ul>
				</div>
			</div>
			<div class="row uniform">
				<div class="12u">
					<ul class="actions">
						<li><input type="submit" class="special" value="Send Message" /></li>
						<li><input type="reset" value="Reset Form" /></li>
					</ul>
				</div>
			</div>
				<!-- <br/> -->
		</form>
		</div>
	</section>
</template>